module.exports = __webpack_public_path__ + "media/src/images/icon__soso--dark-ffec61839a2faa9c17cfee687610daef.png";